// List Coupons
export const GET_COUPON_LIST_REQUEST = "GET_COUPON_LIST_REQUEST";
export const GET_COUPON_LIST_SUCCESS = "GET_COUPON_LIST_SUCCESS";
export const GET_COUPON_LIST_FAIL = "GET_COUPON_LIST_FAIL";
export const GET_COUPON_LIST_RESET = "GET_COUPON_LIST_RESET";

// Get Single Coupon
export const GET_COUPON_DETAILS_REQUEST = "GET_COUPON_DETAILS_REQUEST";
export const GET_COUPON_DETAILS_SUCCESS = "GET_COUPON_DETAILS_SUCCESS";
export const GET_COUPON_DETAILS_FAIL = "GET_COUPON_DETAILS_FAIL";
export const GET_COUPON_DETAILS_RESET = "GET_COUPON_DETAILS_RESET";

// Create Coupon
export const CREATE_COUPON_REQUEST = "CREATE_COUPON_REQUEST";
export const CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS";
export const CREATE_COUPON_FAIL = "CREATE_COUPON_FAIL";
export const CREATE_COUPON_RESET = "CREATE_COUPON_RESET";

// Update Coupon
export const UPDATE_COUPON_REQUEST = "UPDATE_COUPON_REQUEST";
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";
export const UPDATE_COUPON_FAIL = "UPDATE_COUPON_FAIL";
export const UPDATE_COUPON_RESET = "UPDATE_COUPON_RESET";

// Toggle Coupon Status
export const TOGGLE_COUPON_STATUS_REQUEST = "TOGGLE_COUPON_STATUS_REQUEST";
export const TOGGLE_COUPON_STATUS_SUCCESS = "TOGGLE_COUPON_STATUS_SUCCESS";
export const TOGGLE_COUPON_STATUS_FAIL = "TOGGLE_COUPON_STATUS_FAIL";
export const TOGGLE_COUPON_STATUS_RESET = "TOGGLE_COUPON_STATUS_RESET";

// Delete Coupon
export const DELETE_COUPON_REQUEST = "DELETE_COUPON_REQUEST";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const DELETE_COUPON_FAIL = "DELETE_COUPON_FAIL";
export const DELETE_COUPON_RESET = "DELETE_COUPON_RESET";

// Apply Coupon
export const APPLY_COUPON_REQUEST = "APPLY_COUPON_REQUEST";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const APPLY_COUPON_FAIL = "APPLY_COUPON_FAIL";
export const APPLY_COUPON_RESET = "APPLY_COUPON_RESET";

// Validate Coupon
export const VALIDATE_COUPON_REQUEST = "VALIDATE_COUPON_REQUEST";
export const VALIDATE_COUPON_SUCCESS = "VALIDATE_COUPON_SUCCESS";
export const VALIDATE_COUPON_FAIL = "VALIDATE_COUPON_FAIL";
export const VALIDATE_COUPON_RESET = "VALIDATE_COUPON_RESET";
